import { Tabs } from 'antd';
import React from 'react';
import FormSellerInfo from './FormSellerInfo';
import OrderList from './OrderList';
import SellerListDetailProduct from './SellerListDetailProduct';
import SellerListDetailWarehouse from './SellerListDetailWarehouse';
import LogisticTable from './table/LogisticTable';
import ProductTable from './table/ProductTable';
import ReturnList from './ReturnList';
import IntergrationHistory from './IntergrationHistory';

interface Props {
  // tab change
  handleTabChange: Function;
  formData:
    | {
        firstName: string;
        lastName: string;
        contactNumber: string;
        countryCode: string;
        email: string;
        password: string;
        companyName: string;
        address: string;
        phoneNumber: string;
        businessLicense: {
          url: string;
          fileName?: string;
        };
        saleCountry: string;
        monthlyShipment: string;
        numberOfProduct: string;
        amazonSellerId: string;
        state: string;
        companyPhoneNumber: string;
        detailAddress: string;
        companyAddress: string;
        saleCategory: string[];
        saleChannels: string[];
        postalCode: string;
      }
    | undefined;

  // warehouse
  getWarehouseDetail: Function;
  rowDataWarehouse: any;
  totalWarehouse: number;
  //product
  getProductList: Function;
  rowDataProducts: any;
  totalProduct: number;
  //loading
  loading: boolean;
  //sellerListDetail :
  //warehouse
  selectedWarehouse: React.Key[];
  setSelectedWarehouse: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleChangePageLogistic: Function;
  //product
  selectedProduct: React.Key[];
  setSelectedProduct: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleChangePageProduct: Function;
}

const Tabss = ({
  handleTabChange,
  formData,
  getWarehouseDetail,
  rowDataWarehouse,
  totalWarehouse,
  getProductList,
  rowDataProducts,
  totalProduct,
  loading,
  selectedWarehouse,
  setSelectedWarehouse,
  handleChangePageLogistic,
  selectedProduct,
  setSelectedProduct,
  handleChangePageProduct,
}: Props) => {
  return (
    <div className="busk-tabs">
      <Tabs defaultActiveKey="1" onChange={(e) => handleTabChange(e)}>
        <Tabs.TabPane tab="셀러 정보" key="1">
          <FormSellerInfo formData={formData as any} loading={loading} />
        </Tabs.TabPane>

        <Tabs.TabPane tab="물류센터 계약 목록" key="2">
          <SellerListDetailWarehouse
            warehouseData={rowDataWarehouse}
            totalWarehouse={totalWarehouse}
            totalProduct={totalProduct}
            selectedWarehouse={selectedWarehouse}
            selectedProduct={selectedProduct}
          />
          <LogisticTable
            warehouseData={rowDataWarehouse}
            getWarehouseDetail={getWarehouseDetail}
            totalWarehouse={totalWarehouse}
            loading={loading}
            selectedWarehouse={selectedWarehouse}
            setSelectedWarehouse={setSelectedWarehouse}
            handleChangePageLogistic={handleChangePageLogistic}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="상품 목록" key="3">
          <SellerListDetailProduct
            warehouseData={rowDataWarehouse}
            totalWarehouse={totalWarehouse}
            totalProduct={totalProduct}
            selectedWarehouse={selectedWarehouse}
            selectedProduct={selectedProduct}
            rowDataProducts={rowDataProducts}
          />
          <ProductTable
            // productsData={rowDataProducts}
            getProductList={getProductList}
            rowDataProducts={rowDataProducts}
            totalProduct={totalProduct}
            loading={loading}
            selectedProduct={selectedProduct}
            setSelectedProduct={setSelectedProduct}
            handleChangePageProduct={handleChangePageProduct}
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="배송 목록" key="4">
          <OrderList />
        </Tabs.TabPane>

        <Tabs.TabPane tab="반품 목록" key="5">
          <ReturnList type="RETURN" />
        </Tabs.TabPane>

        <Tabs.TabPane tab="폐기 목록" key="6">
          <ReturnList type="DISPOSAL" />
        </Tabs.TabPane>

        <Tabs.TabPane tab="반환 목록" key="7">
          <ReturnList type="TRACKING" />
        </Tabs.TabPane>
        <Tabs.TabPane tab="연동 내역" key="8">
          <IntergrationHistory/>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default Tabss;
